import * as ENDPOINTS from '@/common/constants/endpoints'

import { api } from '../api'

export const getHomeCreditOnboarding = async (
  apiPath?: string,
): Promise<HomeCreditOnboardingResponse | undefined> => {
  const endpoint = apiPath
    ? `${ENDPOINTS.HOME_CREDIT_BASE_PATH}/${apiPath}`
    : ENDPOINTS.HOME_CREDIT_ONBOARDING

  return api<HomeCreditOnboardingResponse>(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export interface ListItemByPathResponse {
  props: {
    items: ListItemData[]
  }
}

export const getListItemByPath = async (
  path: string,
): Promise<ListItemByPathResponse | undefined> => {
  const endpoint = `${ENDPOINTS.HOME_CREDIT_BASE_PATH}/${path}`

  return api<ListItemByPathResponse>(endpoint, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
